import '../../../../assets/css/screens/serviceprovider/dashboard/workerprofile/WorkerProfile.css';
import React, { useState, useRef, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Bell, MapPin, Star, Edit2, Phone, Mail, ShieldCheck,
  Home, Briefcase, Target, DollarSign, HelpCircle,
  Headphones, Settings, LogOut, ChevronRight, Camera,
  User, RefreshCw
} from 'lucide-react';
import Swal from 'sweetalert2';
import { ArrowLeft, X, Save } from 'lucide-react';
import AppContext from '../../../../context/AppContext';
// ── Import Modal ──
import EditProfileModal from '../../../../components/serviceprovider/workerdashboard/editprofilemodal/EditProfileModal';
import axios from 'axios';


const SERVICES = [
  "Electrician",
  "Plumber",
  "AC Technician",
  "Carpenter",
  "Painter"
];
const MENU_ITEMS = [
  { icon: Home, label: 'Home', path: '/worker-dashboard', color: '#0491e1', bg: 'rgba(4,145,225,0.12)' },
  { icon: Target, label: 'My Jobs', path: '/bid-jobs', color: '#f59e0b', bg: 'rgba(245,158,11,0.12)' },
  { icon: DollarSign, label: 'Earnings', path: '/worker-earnings', color: '#10b981', bg: 'rgba(16,185,129,0.12)' },
  { icon: ShieldCheck, label: 'KYC Verification', path: '/worker-kyc', color: '#0491e1', bg: 'rgba(4,145,225,0.12)' },
  { icon: Bell, label: 'Notifications', path: '/worker-notifications', color: '#ef4444', bg: 'rgba(239,68,68,0.12)' },
  { icon: HelpCircle, label: 'FAQs', path: '/worker-faq', color: '#8b5cf6', bg: 'rgba(139,92,246,0.12)' },
  { icon: Headphones, label: 'Support', path: '/worker-support', color: '#0491e1', bg: 'rgba(4,145,225,0.12)' },
  { icon: Settings, label: 'Settings', path: '/worker-settings', color: '#484745', bg: 'rgba(72,71,69,0.10)' },
];

/* ── Switch Modal ── */
const SwitchModal = ({ onClose, onSwitchNow }) => (
<div className="modal-overlay" onClick={onClose}>
  <div className="modal-box" onClick={(e) => e.stopPropagation()}>
      <div className="wp-switch-modal__icon"><RefreshCw size={28} /></div>
      <h3 className="wp-switch-modal__title">Switch to Customer</h3>
      <p className="wp-switch-modal__desc">
        Login with your customer account to book services. You can switch back anytime.
      </p>
      <div className="wp-switch-modal__actions">
        <button className="wp-modal__cancel" onClick={onClose}>Cancel</button>
        <button className="wp-switch-modal__confirm" onClick={onSwitchNow}>
          <RefreshCw size={15} /> Switch Now
        </button>
      </div>
    </div>
  </div>
);

/* ── Desktop Edit Full Page ── */
const DeskEditPage = ({ form, onChange, onSave, onClose, avatarRef, profileImage, setProfileImage }) => (
  <div className="wp-desk-edit-page">
    <div className="wp-desk-edit-wrap">
      <div className="wp-desk-edit__header">
        <h2>Edit Profile</h2>
        <button className="wp-desk-edit__close" onClick={onClose}><X size={20} /></button>
      </div>

      <div className="wp-desk-edit__avatar-wrap">
        <div className="wp-desk-edit__avatar" onClick={() => avatarRef.current.click()}>
          {profileImage
            ? <img src={profileImage} alt="av" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
            : <User size={40} />
          }
          <button className="wp-desk-edit__cam" type="button"><Camera size={16} /></button>
        </div>
        <input
          ref={avatarRef}
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={e => { const f = e.target.files[0]; if (f) setProfileImage(URL.createObjectURL(f)); }}
        />
      </div>

      <div className="wp-desk-edit__grid">
        {[
          { key: 'name', label: 'Full Name', type: 'text' },
          { key: 'title', label: 'Profession / Title', type: 'text' },
          { key: 'phone', label: 'Phone Number', type: 'tel' },
          { key: 'email', label: 'Email', type: 'email' },
          { key: 'cnic', label: 'CNIC', type: 'text', placeholder: '35202-1234567-1' },
          { key: 'city', label: 'City', type: 'text' },
          { key: 'location', label: 'Location', type: 'text' },
          { key: 'experience', label: 'Experience', type: 'text' },
          { key: 'hourlyRate', label: 'Hourly Rate (PKR)', type: 'number' },
         
        ].map(f => (
          <div key={f.key} className="wp-field">
            <label>{f.label}</label>
            <input
              type={f.type}
              value={form[f.key] || ''}
              placeholder={f.placeholder || ''}
              onChange={e => onChange(f.key, e.target.value)}
            />
          </div>
        ))}

        <div className="wp-field">
          <label>Service</label>
          <select value={form.service || ''} onChange={e => onChange('service', e.target.value)} className="wp-field__select">
            {SERVICES.map(s => <option key={s}>{s}</option>)}
          </select>
        </div>

        <div className="wp-field wp-field--full">
          <label>Bio</label>
          <textarea value={form.about || ''} onChange={e => onChange('about', e.target.value)} rows={4} />
        </div>
      </div>

      <div className="wp-desk-edit__actions">
        <button className="wp-modal__cancel" onClick={onClose}>Cancel</button>
        <button className="wp-modal__save" onClick={onSave}><Save size={15} /> Save Changes</button>
      </div>
    </div>
  </div>
);

/* ════ MAIN COMPONENT ════ */
const WorkerProfile = () => {
  const { baseUrl,authToken, setAuthToken, kycStatus } = useContext(AppContext);
  const navigate = useNavigate();

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [cnic, setCnic] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [bio, setBio] = useState("");
  const [selectService, setSelectService] = useState("");
  const [experience, setExperience] = useState("");
  const [hourlyRate, setHourlyRate] = useState("");
  const [professionalTitle, setProfessionalTitle] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [form, setForm] = useState({});
  const [loggedInWorker, setLoggedInWorker] = useState(null);
  

  const avatarRef = useRef();


  // update profile
const updateProfile = () => {

  // password validation
  if (newPassword && newPassword !== confirmPassword) {
    alert("Passwords do not match");
    return;
  }

  const form = new FormData();

  form.append("fullName", fullName);
  form.append("email", email);
  form.append("phoneNumber", phoneNumber);
  form.append("cnic", cnic);
  form.append("city", city);
  form.append("address", address);
  form.append("bio", bio);

  form.append("service", selectService);
  form.append("experience", experience);
  form.append("hourlyRate", hourlyRate);
  form.append("professionalTitle", professionalTitle);

  if (newPassword) {
    form.append("password", newPassword);
  }

  const file = avatarRef.current?.files?.[0];

  if (file) {
    form.append("profileImage", file);
  }

  axios.post(`${baseUrl}/worker/updateprofile`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      "Content-Type": "multipart/form-data"
    }
  })
  .then((res) => {

    console.log(res.data);

    if (res.data.success) {

      Swal.fire({
  icon: 'success',
  title: 'Profile Updated',
  text: 'Your profile has been updated successfully',
  timer: 1800,
  showConfirmButton: false
});

      viewProfile();

      setDeskEdit(false);
      setEditModal(false);

    } else {
    Swal.fire({
  icon: 'error',
  title: 'Update Failed',
  text: 'Something went wrong'
});
    }

  })
  .catch((err) => {

    console.log("UPDATE ERROR:", err.response?.data || err);

    alert("Update failed");
  });
};


const handleProtectedNavigation = (path) => {

  // Ye pages KYC approval ke bina bhi access honge
  const allowedRoutes = [
    '/worker-kyc',
    '/worker-faq',
    'worker-dashboard',
  ];

  if (
    kycStatus !== "approved" &&
    !allowedRoutes.includes(path)
  ) {
    Swal.fire({
      icon: "warning",
      title: "KYC Required",
      text: "Your KYC has not been approved yet. Please complete your KYC first.",
    });

    navigate('/worker-kyc');
    return;
  }

  navigate(path);
};
  // view profile
 const viewProfile = () => {

  const token = localStorage.getItem("authToken");

  axios.get(`${baseUrl}/worker/viewprofile`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((res) => {

    console.log("WORKER PROFILE:", res.data);

    if (res.data.success) {

      const profile = res.data.serviceprovider;

      setFullName(profile?.fullName || "");
      setEmail(profile?.email || "");
      setPhoneNumber(profile?.phoneNumber || "");
      setCnic(profile?.cnic || "");
      setCity(profile?.city || "");
      setAddress(profile?.address || "");
      setBio(profile?.bio || "");
      setSelectService(profile?.service || "");
      setExperience(profile?.experience || "");
      setHourlyRate(profile?.hourlyRate || "");
      setProfessionalTitle(profile?.professionalTitle || "");

      // optional image
      if (profile?.profileImage) {
        setProfileImage(profile.profileImage);
      }
    }
  })
  .catch((err) => {
    console.log("PROFILE ERROR:", err.response?.data || err.message);
  });
};

  useEffect(() => {
    viewProfile();
  }, []);
// sweet alert
const save = async () => {

 const result = await Swal.fire({
  title: 'Save Changes?',
  text: 'Do you want to update your profile?',
  icon: 'question',
  showCancelButton: true,
  confirmButtonColor: '#0491e1',
  cancelButtonColor: '#6b7280',
  confirmButtonText: 'Yes, Save',
  cancelButtonText: 'Cancel',

  // add this
  customClass: {
    popup: 'my-swal-popup'
  }
});


  if (!result.isConfirmed) return;

  updateProfile();
};

  const [editModal, setEditModal] = useState(false);  // mobile modal
  const [deskEdit, setDeskEdit] = useState(false);  // desktop full page
  const [switchModal, setSwitchModal] = useState(false);

  const openMobileEdit = () => setEditModal(true);
  const openDesktopEdit = () => setDeskEdit(true);
  const closeMobileEdit = () => setEditModal(false);
  const closeEdit = () => setDeskEdit(false);
 
  // logout
// logout with sweet alert
const handleLogout = async () => {

  const result = await Swal.fire({
    title: 'Log Out?',
    text: 'Are you sure you want to logout?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#ef4444',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Yes, Logout',
    cancelButtonText: 'Cancel'
  });

  // sirf YES par logout hoga
  if (!result.isConfirmed) return;

  try {

    const res = await axios.post(
      `${baseUrl}/worker/logout`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    console.log(res.data);

 if (res.data.success) {

  localStorage.removeItem("authToken");
  localStorage.removeItem("email");
  localStorage.removeItem("password");
  localStorage.removeItem("workerLoggedIn");

  setAuthToken("");

  await Swal.fire({
    icon: 'success',
    title: 'Logged Out',
    text: 'You have been logged out successfully',
    timer: 1500,
    showConfirmButton: false
  });

  navigate('/');

}

  } catch (err) {

    console.log("LOGOUT ERROR:", err.response?.data || err.message);

    // Swal.fire({
    //   icon: 'error',
    //   title: 'Logout Failed',
    //   text: 'Something went wrong'
    // });

  }
};
  const handleSwitchNow = () => { setSwitchModal(false); navigate('/'); };

 const handleHeroAvatar = e => {
  const f = e.target.files[0];
  if (f) setProfileImage(URL.createObjectURL(f));
};

const change = (key, value) => {
  switch (key) {
    case 'name': setFullName(value); break;
    case 'email': setEmail(value); break;
    case 'phone': setPhoneNumber(value); break;
    case 'cnic': setCnic(value); break;
    case 'city': setCity(value); break;
    case 'location': setAddress(value); break;
    case 'about': setBio(value); break;
    case 'service': setSelectService(value); break;
    case 'experience': setExperience(value); break;
    case 'hourlyRate': setHourlyRate(value); break;
    case 'title': setProfessionalTitle(value); break;
    case 'password': setNewPassword(value); break;
    case 'confirmPass': setConfirmPassword(value); break;
    default: break;
  }
};


  /* Desktop edit page */
  if (deskEdit) {
    return (
      <DeskEditPage
 form={{
  name: fullName,
  email: email,
  phone: phoneNumber,
  cnic: cnic,
  city: city,
  location: address,
  about: bio,
  service: selectService,
  experience: experience,
  hourlyRate: hourlyRate,
  title: professionalTitle,
  password: newPassword,
  confirmPass: confirmPassword
}}
  onChange={change}
  onSave={save}
  onClose={closeEdit}
  avatarRef={avatarRef}
  profileImage={profileImage}
  setProfileImage={setProfileImage}
/>
    );
  }




  /* ── Profile View ── */
  return (
    <div className="wp-page">

      {/* Mobile Header */}
      <div className="wp-mobile-header">
        <button className="wp-mobile-header__back" onClick={() => navigate(-1)}>
          <ArrowLeft size={22} />
        </button>
        <h2 className="wp-mobile-header__title">Profile</h2>
      </div>

      {/* Hero */}
      <div className="wp-hero">
        <div className="wp-hero__avatar">
         {profileImage
  ? <img src={profileImage} alt="av" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
  : <User size={38} />
}
          <button className="wp-hero__cam" onClick={() => avatarRef.current.click()}>
            <Camera size={14} />
          </button>
          <input ref={avatarRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleHeroAvatar} />
        </div>
        <h2 className="wp-hero__name">{fullName}</h2>
        <p className="wp-hero__title">{professionalTitle}</p>
        <div className="wp-hero__rating">
          <Star size={14} fill="#f59e0b" color="#f59e0b" />
          <span>4.8</span>
          <span className="wp-hero__reviews">(127 reviews)</span>
        </div>
        <div className="wp-hero__location"><MapPin size={13} /> {address}</div>
      </div>

      {/* Stats */}
      <div className="wp-stats">
        <div className="wp-stat"><strong>47</strong><span>Jobs Done</span></div>
        <div className="wp-stat wp-stat--mid"><strong>{experience}</strong><span>Experience</span></div>
        <div className="wp-stat wp-stat--green"><strong>98%</strong><span>Completion</span></div>
      </div>

      {/* Edit Profile Buttons */}
      <div className="wp-edit-wrap">
        {/* Mobile → opens modal */}
        <button className="wp-edit-btn wp-edit-btn--mobile" onClick={openMobileEdit}>
          <Edit2 size={15} /> Edit Profile
        </button>
        {/* Desktop → opens full page */}
        <button className="wp-edit-btn wp-edit-btn--desk" onClick={openDesktopEdit}>
          <Edit2 size={15} /> Edit Profile
        </button>
      </div>

      {/* Info Cards */}
      <div className="wp-info-cards">
        {/* <div className="wp-info-card">
          <Phone size={17} className="wp-info-card__icon wp-info-card__icon--blue" />
          <span>{phoneNumber}</span>
        </div> */}
        <div className="wp-info-card">
          <Mail size={17} className="wp-info-card__icon wp-info-card__icon--green" />
          <span>{email}</span>
        </div>
        <div className="wp-info-card">
          <ShieldCheck size={17} className="wp-info-card__icon wp-info-card__icon--teal" />
          <span>KYC Verified ✓</span>
        </div>
      </div>

      {/* Switch to Customer */}
      <div className="wp-extra-cards">
        <div className="wp-extra-card wp-extra-card--switch" onClick={() => setSwitchModal(true)}>
          <div className="wp-extra-card__left">
            <div className="wp-extra-card__icon" style={{ background: 'rgba(139,92,246,0.12)', color: '#8b5cf6' }}>
              <RefreshCw size={18} />
            </div>
            <div className="wp-extra-card__info">
              <span className="wp-extra-card__label">Switch to Customer</span>
              <span className="wp-extra-card__sub">Login as a customer to book services</span>
            </div>
          </div>
          <ChevronRight size={16} className="wp-extra-card__arrow" />
        </div>
      </div>

      {/* Menu */}
      <div className="wp-menu">
        {MENU_ITEMS.map(item => {
          const Icon = item.icon;
          return (
<button
  key={item.path}
  className="wp-menu-item"
  onClick={() => handleProtectedNavigation(item.path)}
>              <div className="wp-menu-item__icon" style={{ background: item.bg, color: item.color }}>
                <Icon size={18} />
              </div>
              <span className="wp-menu-item__label">{item.label}</span>
              <ChevronRight size={16} className="wp-menu-item__arrow" />
            </button>
          );
        })}
      </div>

      {/* Logout */}
      <div className="wp-logout-wrap">
        <button className="wp-logout-btn" onClick={handleLogout}>
          <LogOut size={17} /> Log Out
        </button>
      </div>

      {/* Mobile Edit Modal */}
      {editModal && (
        <EditProfileModal
         form={{
  name: fullName,
  email: email,
  phone: phoneNumber,
  cnic: cnic,
  city: city,
  location: address,
  about: bio,
  service: selectService,
  experience: experience,
  hourlyRate: hourlyRate,
  title: professionalTitle,
}}
          onChange={change}
          onSave={save}
          onClose={closeMobileEdit}
        />
      )}

      {/* Switch Modal */}
      {switchModal && (
        <SwitchModal
          onClose={() => setSwitchModal(false)}
          onSwitchNow={handleSwitchNow}
        />
      )}

    </div>
  );
};

export default WorkerProfile;